import { cn } from "../utils/cn";

type SwitchProps = {
  label: string;
  checked?: boolean;
  state?: "default" | "hover" | "active" | "focus" | "disabled";
};

export function Switch({ label, checked = false, onChange, state = "default" }: SwitchProps) {
  const stateClasses =
    state === "hover"
      ? "ring-1 ring-border"
      : state === "active"
        ? "ring-1 ring-border"
        : state === "focus"
          ? "outline outline-2 outline-primary/40 outline-offset-2"
          : "";
  const disabled = state === "disabled";
  return (
    <label className={cn("inline-flex items-center gap-2 text-sm text-text", disabled && "opacity-50")}>
      <span>{label}</span>
      <button
        type="button"
        onClick={() => onChange?.(!checked)}
        disabled={disabled}
        className={cn(
          "h-5 w-9 rounded-full border border-border flex items-center transition",
          checked && "bg-primary/20",
          !disabled && "cursor-pointer",
          stateClasses
        )}
      >
        <span className={cn("h-4 w-4 rounded-full bg-muted transition", checked && "translate-x-4 bg-primary")} />
      </button>
    </label>
  );
}
